import React, { Component } from "react";
import { TableStore, RowStore } from "@stores/tablestore";
import render from "ynf-core-engine/render";
import { v4 as uuid } from "uuid";
import styles from "@src/components/import/downLoadTpl.module.less";
import * as services from "@api";
import { isType } from "@src/utils";
import { DownLoadType } from "@src/actions/bill";
import { ExportType, commonExport } from "@src/actions/bill";
import { buildExportParams } from "@src/actions/bill";

const TinperNext = window.TinperNext || {};
const { Button } = TinperNext;

const { ROW_KEY = "id" } = {};
const LIST_LIB_CODE = "ynf-lib-view"; // 组件库名
export default class DownLoadTpl extends Component {
  serviceCode = "bank_u8c";
  state = {
    columns: [
      {
        alias: "tplVersion",
        caption: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80043', '版本'),
        controlType: "Input",
        libCode: "ynf-lib-dataentry",
        storeField: "tplVersion",
        store: "tplTableStore",
        readOnly: true,
      },
      {
        alias: "code",
        caption: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80032', '模板编号'),
        controlType: "Input",
        libCode: "ynf-lib-dataentry",
        storeField: "code",
        store: "tplTableStore",
        readOnly: true,
      },
      {
        alias: "name",
        caption: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80039', '模板名称'),
        controlType: "Input",
        libCode: "ynf-lib-dataentry",
        storeField: "name",
        store: "tplTableStore",
      },
      {
        alias: "parentTplName",
        caption: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8003C', '模板来源'),
        controlType: "Input",
        libCode: "ynf-lib-dataentry",
        storeField: "parentTplName",
        store: "tplTableStore",
      },
      {
        alias: "transType",
        caption: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80044', '交易类型'),
        controlType: "Input",
        libCode: "ynf-lib-dataentry",
        storeField: "transType",
        store: "tplTableStore",
      },
      {
        alias: "createTime",
        caption: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80033', '创建时间'),
        controlType: "Input",
        libCode: "ynf-lib-dataentry",
        storeField: "createTime",
        store: "tplTableStore",
      },
      {
        alias: "updateTime",
        caption: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8003A', '更新时间'),
        controlType: "Input",
        libCode: "ynf-lib-dataentry",
        storeField: "updateTime",
        store: "tplTableStore",
      },
      {
        alias: "operatorName",
        caption: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8003D', '操作人'),
        controlType: "Input",
        libCode: "ynf-lib-dataentry",
        storeField: "operatorName",
        store: "tplTableStore",
      },
      {
        alias: "devStatus",
        caption: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80045', '状态'),
        controlType: "Input",
        libCode: "ynf-lib-dataentry",
        storeField: "devStatus",
        store: "tplTableStore",
      },
      {
        alias: "devSystemTpl",
        caption: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80034', '是否默认模板'),
        controlType: "Input",
        libCode: "ynf-lib-dataentry",
        storeField: "devSystemTpl",
        store: "tplTableStore",
      },
      // {
      //   alias: 'devAllInOneSheet',
      //   caption: '模板形式',

      //   bHidden: false,
      //   bShowIt: true,
      //   bCanModify: false,
      //   controlType: 'Input',
      //   // enumArray: '[{"nameType":"text","value":"多页签","key":"true"},{"nameType":"text","value":"单页签","key":"false"}]',
      //   bMustSelect: false,
      //   bIsNull: true,
      // }
    ],
    tplData: [],
    selectedRowIndex: 0,
    selectedList: {},
    tableAlias: uuid(),
    defaultKey: "",
    tplTableStore: null,
  };

  selectedObj = {};
  componentDidMount(): void {
    this.serviceCode =
      this.props.rootStore.pageStore.params?.serviceCode || "bank_u8c";
    this.getTemplateList();
  }

  // 获取模板列表
  getTemplateList = async () => {
    const { pageStore = {}, utils } = this.props.rootStore;
    const detailBillNo = this.props.options.detailBillNo;
    const requestData = {
      params: {
        feV: 6,
        currentDomainKey: pageStore.params?.domainKey,
        terminalType: pageStore.query?.terminalType,
        busiObj: pageStore.params?.busiObj,
      },
      data: {
        billnum: detailBillNo,
        // tplId: pageStore.params.tplId,
      },
      proxy: false,
      rawResponse: false,
      handleErrCode: true,
    };
    const res = await services.getTplList(requestData);

    if (res.code !== 200) {
      utils.message.danger(res.message || lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80046', '获取模板失败'));
      // quantum.utils.err()
      return;
    }
    let tplData = res?.data || [];
    let defaultKey = "";
    let selectObjCont = {};
    tplData = tplData.map((row) => {
      // 处理状态
      row.devStatus = row.published || row.systemTpl ? lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80036', '已发布', undefined, { returnStr: true }) : lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80035', '未发布', undefined, { returnStr: true });
      // 处理预置数据
      row.devSystemTpl = lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80038', '否', undefined, { returnStr: true });
      row[ROW_KEY] = row?.id || uuid();
      if (row.isDefault) {
        defaultKey = row[ROW_KEY];
        selectObjCont = { ...row };
        row.devSystemTpl = lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8003B', '是', undefined, { returnStr: true });
      }
      return row;
    });
    defaultKey = defaultKey || tplData?.[0][ROW_KEY];
    this.selectedObj = {
      selectedList: { ...(selectObjCont || tplData?.[0]) },
      selectedRowIndex: defaultKey,
    };
    this.setState({ tplData, defaultKey });
  };

  // 下载模板
  handleDownload = async () => {
    const { type } = this.props;
    switch (type) {
      case DownLoadType.downLoadTpl:
        await this.downLoadTpl();
        break;
      case DownLoadType.downUpdateLoadTpl:
        this.downLoadUpdateTpl();
        break;
      default:
        break;
    }
  };

  async downLoadTpl() {
    const { pageStore = {}, utils } = this.props.rootStore;
    const { selectedList = {} } = this.selectedObj;
    const {
      tplId = "",
      systemTpl,
      published,
      templateType,
      name,
      billnum,
    } = selectedList;
    const filename = name || billnum
    if (!tplId && !systemTpl) {
      utils.message.danger(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8003E', '请选择要下载的模板'));
      return; // 没有选中行
    }
    if (!systemTpl && !published) {
      utils.message.danger(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80042', '您选择的模板尚未发布'));
      return;
    }
    let requestData = {
      params: {
        currentDomainKey: pageStore?.params?.domainKey,
        ...pageStore?.query,
      },
      data: {
        tplid: systemTpl ? null : tplId, // 如果是系统模板，就取下载模板自带的，否则就是自定义的，取行里面的
        fromUniteEntrance: true, // 是否是从实施工具过去的，(后端需要)
        systemTpl, // 系统模板
        billnum,
        templateType,
        fileType: "excel", // 导出文件类型downloadType
        filename, // 文件名
        // allInOneSheet: false, // 单页签or多页签模板 刘豪接口不需要
      },
    };
    // 下载模板 前置钩子
    if (isType(this.props.beforeDownLoadTplHook, "Function")) {
      requestData = await this.props.beforeDownLoadTplHook(
        this.props.rootStore,
        requestData
      );
    }
    try {
      const result = await services.downLoadTpl(requestData);
      const blobData = isType(result?.data, 'Blob')? result.data: result;
      await this.exportFile(blobData, filename);
      utils.notice.success({
        message: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8003F', '下载请求已执行完毕'),
        description: `${lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80040', '您发起的模板下载已经完成，文件名为')}${filename}${lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80041', ',请您参阅查看。')}`,
      });
    } catch (err: any) {
      utils.message.danger(err?.msg ?? err?.message);
      return Promise.reject(err);
    } finally {
      // 下载模板 后置钩子
      if (isType(this.props.afterDownLoadTplHook, "Function")) {
        await this.props.afterDownLoadTplHook(this.props.rootStore);
      }
    }
  }

  /**
   * 下载更新模板
   */
  async downLoadUpdateTpl() {
    const { selectedList = {} } = this.selectedObj;
    const {
      tplId = "",
      // systemTpl,
      // published,
      // templateType,
      // name,
      // billnum,
    } = selectedList;
    // 参数构建和导出明细一样
    let requestData = await buildExportParams(
      this.props.rootStore,
      this.props.options,
      ExportType.exportDetail
    );
    requestData.data.importMode = 2;
    requestData.data.tplId = tplId;
    requestData.parmas.tplId = tplId;

    // 下载更新模板 前置钩子
    if (isType(this.props.beforeDownUpdateLoadTplHook, "Function")) {
      requestData = await this.props.beforeDownUpdateLoadTplHook(
        this.props.rootStore,
        requestData
      );
    }
    const res = await commonExport(requestData, this.props.rootStore);
    // 下载更新模板 后置钩子
    if (isType(this.props.afterDownLoadUpdateTplHook, "Function")) {
      await this.props.afterDownLoadUpdateTplHook(this.props.rootStore, res);
    }
  }

  /**
   * 导出文件
   * @param {*} data 接口返回数据
   * @param {*} filename 下载文件名
   */
  exportFile = (data: any, filename: any) => {
    return new Promise<void>((resolve, reject) => {
      const type = data?.type;
      if (type.includes("application/json")) {
        const reader = new FileReader();
        reader.readAsText(data);
        reader.onload = () => {
          const content = reader.result;
          const message = JSON.parse(content); // 错误信息
          reject(message);
        };
      } else {
        // const blob = new Blob([data]) 因为responseType指定接口返回就是Blob实例，所以不用重复创建实例
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(data, filename);
        } else {
          const elink = document.createElement("a");
          elink.download = filename;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(data);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        }
        resolve();
      }
    });
  };

  // 模板列表配置项  
  getTableConfig = () => {
    let { columns, tableAlias, tplData, defaultKey, tplTableStore } =
      this.state;
    const { selectedRowIndex } = this.selectedObj;
    tplTableStore = new TableStore({}, this.props.rootStore);
    // tplTableStore.initColumns(columns);
    tplData.forEach((item, index) => {
      tplTableStore.addRow(new RowStore(index, item));
    });
    // 方便调试，挂载到rootStore 上
    this.props.rootStore.tplTableStore = tplTableStore;
    return {
      libCode: LIST_LIB_CODE, // 组件库
      controlType: "Table", // 组件类型
      referenceType: "model", // 兼容合计
      alias: tableAlias,
      showRowNum: true, // 显示行号
      children: columns, // 表头
      selectedRowIndex, // 当前选中行【单选】
      autoCheckedByClickRows: true, // 点击行即可选中
      hidePagination: true,
      style: { width: "100%" },
      store: tplTableStore,
      rowSelection: {
        selectedRowKeys: [defaultKey], // 指定选中项的 key 数组
        multiple: false, // 单选
      },
      getSelectedDataFunc: (selectedList, selectedRowIndex) => {
        // 单选 返回当前选中的数据数组
        // this.setState({ selectedRowIndex, selectedList })
        // this.props.ctx.apis.store.updateViewState(tableAlias,'selectedRowIndex',selectedRowIndex)
        // 注意：需要用回调中提供的参数 newData，去更新 state 或 store 中的 data 属性值，否则当表格重新render的时候，已选数据会被冲刷掉。
        this.selectedObj = { selectedList: selectedList?.data, selectedRowIndex };
      },
    };
  };

  getFieldId = () => {
    const { pageStore = {} } = this.props.rootStore;
    // const { fieldid, fieldidPrefix } = this.props || {};
    return `${pageStore.params?.billNo}|${DownLoadType[this.props.type]}|btn`;
  };

  render() {
    return (
      <div className="tpl-content" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* {render(this.getToolBar(),{ rootStore: this.props.rootStore })} */}
        <div className={styles["tpl-btns"]}>
          <Button
            fieldid={this.getFieldId()}
            type="primary"
            onClick={this.handleDownload}
          >
            {lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80037', '下载')}
          </Button>
        </div>
        {render(this.getTableConfig(), { rootStore: this.props.rootStore })}
      </div>
    );
  }
}

// const TinperNext = window.TinperNext || {};
// const { Table, Switch } = TinperNext;
// import React, { Component } from 'react';
// const columns = [
//     { title: "员工编号", dataIndex: "a", key: "a", width: 150 },
//     { title: "员工姓名", dataIndex: "b", key: "b", width: 100 },
//     { title: "性别", dataIndex: "c", key: "c", width: 100 },
//     { title: "部门", dataIndex: "d", key: "d", width: 100 },
//     { title: "职级", dataIndex: "e", key: "e", width: 100 }
// ];
// const data = [
//     { a: "ASVAL_20190328", b: "小张", c: "男", d: "财务1科", e: "M1", key: "1" },
//     { a: "ASVAL_20190320", b: "小明", c: "男", d: "财务2科", e: "T1", key: "2", children: [
//             { a: "ASVAL_20190320", b: "小明", c: "男", d: "财务2科", e: "T1", key: "221" },
//             { a: "ASVAL_20190320", b: "小明", c: "男", d: "财务2科", e: "T1", key: "222", children: [
//                     { a: "ASVAL_20190320", b: "小明", c: "男", d: "财务2科", e: "T1", key: "2221" },
//                     { a: "ASVAL_20190320", b: "小明", c: "男", d: "财务2科", e: "T1", key: "2222" }
//                 ] },
//         ] },
//     { a: "ASVAL_20190312", b: "小红", c: "女", d: "财务2科", e: "T2", key: "3" }
// ];
// [...new Array(100)].forEach((_item, index) => {
//     data.push({
//         a: `ASVAL_2019033${index}`,
//         b: `员工${index + 1}`,
//         c: `男`,
//         d: `财务${index + 1}科`,
//         e: `M${index + 2}`,
//         key: `${4 + index}`,
//     });
// });
// class Demo12 extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             data: data,
//             selectedRowKeys: [],
//             pagination: {
//                 showSizeChanger: true,
//                 current: 1,
//                 pageSize: 10
//             },
//             checkStrictly: false
//         };
//     }
//     /**
//      *@param selectedList:当前选中的行数据
//      *@param record 当前操作行数据
//      *@param index 当前操作行索引
//      *@param newData 进行多选操作之后的新数据 data
//      * @memberof Demo12
//      */
//     getSelectedDataFunc = (selectedList, _record, index, newData) => {
//         console.log("selectedList", selectedList, "index", index, 'newData', newData);
//         // 注意：需要用回调中提供的参数 newData，去更新 state 或 store 中的 data 属性值，否则当表格重新render的时候，已选数据会被冲刷掉。

//     };
//     onChange = (pageInfo) => {
//         const { pagination } = this.state;
//         const { current, pageSize } = pageInfo;
//         this.setState({
//             pagination: {
//                 ...pagination,
//                 current,
//                 pageSize
//             }
//         });
//     };
//     checkStrictlyChange = () => {
//         this.setState({
//             checkStrictly: !this.state.checkStrictly
//         });
//     };
//     render() {
//         let rowSelection = {
//             checkStrictly: this.state.checkStrictly,
//             columnWidth: 80,
//             // selectedRowKeys: this.state.selectedRowKeys,
//             getCheckboxProps: (record) => ({
//                 disabled: record.key == '3',
//                 name: record.b,
//             }),
//             // onChange: (selectedRowKeys: TableProps['selectedRowKeys'], selectedRows: TableProps['data']) => {
//             //     console.log('selectedRowKeys', selectedRowKeys, 'selectedRows', selectedRows)
//             //     this.setState({
//             //         selectedRowKeys
//             //     })
//             // },
//             // onSelectAll: (check: boolean, selectedRows: TableProps['data'], changeRows: TableProps['data']) => {
//             //     console.log('check', check, 'selectedRows', selectedRows, 'changeRows', changeRows)
//             // },
//             selections: [
//                 Table.SELECTION_ALL,
//                 Table.SELECTION_INVERT,
//                 Table.SELECTION_NONE,
//                 {
//                     key: "odd",
//                     text: "Select Odd Row",
//                     onSelect: (changableRowKeys) => {
//                         console.log('changableRowKeys', changableRowKeys);
//                     }
//                 },
//                 {
//                     key: "even",
//                     text: "Select Even Row",
//                     onSelect: (changableRowKeys) => {
//                         console.log('changableRowKeys', changableRowKeys);
//                     }
//                 }
//             ],
//             onSelectInvert: (selectedRowKeys) => {
//                 console.log('selectedRowKeys', selectedRowKeys);
//             },
//             onSelectNone: () => {
//                 console.log('清空选择');
//             }
//         };
//         return (<>
// 				   <div style={{ paddingBottom: '15px' }}>父子节点受控: <Switch checked={!this.state.checkStrictly} onChange={this.checkStrictlyChange}/></div>
// 				 <Table bordered columns={columns} data={data} rowSelection={rowSelection}
//         //    autoCheckedByClickRows={false}
//         pagination={{}} onChange={this.onChange} getSelectedDataFunc={this.getSelectedDataFunc}/>
// 			   </>);
//     }
// }
// export default Demo12;
